import React from "react";
import { MentionsInput, Mention } from "react-mentions";
import { get } from "lodash";
import useStyles from "./styles";
import useKeyPress from "../../../hooks/useKeyPress";

const TextAreaMention = props => {
  const classes = useStyles();
  const enterPress = useKeyPress("Enter");
  const inputProps = { ...props };
  // ##@user communitation
  return (
    <MentionsInput
      {...inputProps}
      value={props.replyResponseMessageText}
      // singleLine
      className={`${classes.mentionInput} mention-input`}
      onKeyPress={event =>
        get(inputProps, "onEnterSubmit", null) &&
        inputProps.onEnterSubmit(event, enterPress)
      }
      onKeyDown={event =>
        get(inputProps, "onEnterSubmit", null) &&
        inputProps.onEnterSubmit(event, enterPress)
      }>
      <Mention
        trigger="@"
        data={props.usersListData}
        // markup="@__display__"
        renderSuggestion={(
          entry,
          search,
          highlightedDisplay,
          index,
          focused
        ) => {
          return `${entry.title}`;
        }}
      />

      <Mention
        trigger="#"
        data={props.strengthListData}
        // markup="@__display__"
        renderSuggestion={(
          entry,
          search,
          highlightedDisplay,
          index,
          focused
        ) => {
          return `${entry.id}`;
        }}
      />
    </MentionsInput>
  );
};

export default TextAreaMention;
